/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Today_Checkin_Note_NoneInputs */

const en_us2_today_checkin_note_none = /** @type {(inputs: Today_Checkin_Note_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No soreness today. Workout ${i?.label} goes ahead as planned.`)
};

const pt_br2_today_checkin_note_none = /** @type {(inputs: Today_Checkin_Note_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem dor hoje. O Treino ${i?.label} segue como planejado.`)
};

const es_419_today_checkin_note_none = /** @type {(inputs: Today_Checkin_Note_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sin dolor hoy. El Entrenamiento ${i?.label} sigue según lo planeado.`)
};

const pt_pt2_today_checkin_note_none = /** @type {(inputs: Today_Checkin_Note_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem dor hoje. O Treino ${i?.label} segue como planeado.`)
};

const fr_fr2_today_checkin_note_none = /** @type {(inputs: Today_Checkin_Note_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pas de courbatures aujourd'hui. La séance ${i?.label} se déroule comme prévu.`)
};

const de_de2_today_checkin_note_none = /** @type {(inputs: Today_Checkin_Note_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Heute kein Muskelkater. Training ${i?.label} läuft wie geplant.`)
};

const it_it2_today_checkin_note_none = /** @type {(inputs: Today_Checkin_Note_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nessun dolore oggi. L'allenamento ${i?.label} procede come previsto.`)
};

/**
* | output |
* | --- |
* | "No soreness today. Workout {label} goes ahead as planned." |
*
* @param {Today_Checkin_Note_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_note_none = /** @type {((inputs: Today_Checkin_Note_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_Note_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_note_none(inputs)
	if (locale === "es-419") return es_419_today_checkin_note_none(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_note_none(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_note_none(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_note_none(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_note_none(inputs)
	return en_us2_today_checkin_note_none(inputs)
});
export { today_checkin_note_none as "today.checkin_note_none" }